import { EventFormQuestionOnEvent } from "@ac-expo/api-types";
import { CreateEventFormAnswersForm } from "@ac-expo/api";
import { EventFormQuestionAnswerType } from "@prisma/client";
import { Control } from "react-hook-form";
import EventFormShortText from "./EventFormShortText";
import EventFormLongText from "./EventFormLongText";
import EventFormMultipleChoice from "./EventFormMultipleChoice";
import EventFormCheckbox from "./EventFormCheckbox";
import EventFormList from "./EventFormList";

interface EventFormProps {
  eventFormQuestionsOnEvent: EventFormQuestionOnEvent[];
  control?: Control<CreateEventFormAnswersForm>;
  isReadOnly?: boolean;
  fieldIndices?: number[];
}

export default function EventForm({
  eventFormQuestionsOnEvent,
  control,
  isReadOnly = false,
  fieldIndices,
}: EventFormProps) {
  return (
    <div className="space-y-4">
      {eventFormQuestionsOnEvent.map((questionOnEvent, mapIndex) => {
        const question = questionOnEvent.question;
        const index = fieldIndices ? fieldIndices[mapIndex] : mapIndex;

        switch (question.answerType) {
          case EventFormQuestionAnswerType.short_text:
            return (
              <EventFormShortText
                key={question.id}
                question={question}
                control={control}
                index={index}
                isReadOnly={isReadOnly}
              />
            );
          case EventFormQuestionAnswerType.long_text:
            return (
              <EventFormLongText
                key={question.id}
                question={question}
                control={control}
                index={index}
                isReadOnly={isReadOnly}
              />
            );
          case EventFormQuestionAnswerType.multiple_choice:
            return (
              <EventFormMultipleChoice
                key={question.id}
                question={question}
                control={control}
                index={index}
                isReadOnly={isReadOnly}
              />
            );
          case EventFormQuestionAnswerType.checkbox:
            return (
              <EventFormCheckbox
                key={question.id}
                question={question}
                control={control}
                index={index}
                isReadOnly={isReadOnly}
              />
            );
          case EventFormQuestionAnswerType.list:
            return (
              <EventFormList
                key={question.id}
                question={question}
                control={control}
                index={index}
                isReadOnly={isReadOnly}
              />
            );
          default:
            return null;
        }
      })}
    </div>
  );
}
